import cookie from './cookies';
import queryString from './query-string';

// O marketing usou o nome `utm_*` em vez de `traffic_*`, aqui corrigimos isso
const checkParameters = () => {
    const source = queryString.get<string>('utm_source')!;

    if (source) {
        cookie.put('traffic_source', source, 90);

        const traffic = queryString.getAll<{ utm_medium: string, utm_campaign: string, utm_term: string }>(['utm_medium', 'utm_campaign', 'utm_term']);

        cookie.put('traffic_medium', traffic.utm_medium, 90);

        cookie.put('traffic_campaign', traffic.utm_campaign, 90);

        cookie.put('traffic_value', traffic.utm_term, 90);
    } else if (!cookie.get('traffic_medium')) {
        // Se não existir o cookie `traffic_medium`, então o cookie `traffic_source` NÃO vem de Ads,
        // ou seja, ou ele não existe, ou ele está com o valor do cookie `__trf.src`,
        // em ambos casos atualiza o cookie `traffic_source` com o valor do cookie `__trf.src`
        const source = cookie.get('__trf.src');

        if (source)
            cookie.put('traffic_source', source, 90);
    }
};

const marketing = { checkParameters };

export default marketing;
